<template lang="pug">
aside(:class="{ open }")
  button(@click.stop.prevent="toggle", @keypress.enter.stop.prevent="toggle")
    i.fa.fa-times
    span {{ field.values[0] }}
  Expand
    small(v-if="open")
      span(v-html="field.values[1]")
</template>

<script>
import Expand from "../../transitions/Expand.vue";
export default {
  name: "Tooltip",
  props: {
    field: Object,
  },
  components: {
    Expand,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
aside {
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  appearance: none;
  .frame > &,
  .frame__inner > & {
    flex: 0 0 auto;
    margin: 0 0 1rem;
  }
}

button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  outline: none;
  border: none;
  background: none;
  transition: 0.25s ease;
  appearance: none;
  padding: 0.875rem 0.75rem 0.75rem;
  cursor: pointer;
  padding: 0;
  margin-left: -1rem;

  span {
    font-weight: 300;
    line-height: 1;
    color: $blue;
    text-align: left;
    padding-top: 0.125rem;
  }

  &:hover {
    i {
      opacity: 0.5;
    }
  }

  i {
    transform: rotate(45deg);
    transition: 0.25s ease;
    font-size: 0.75rem;
    opacity: 0;
    line-height: 0;
    .open & {
      opacity: 1;
      transform: rotate(0deg);
    }
  }
}

small {
  margin: 0;
  padding: 0;
  font-size: 14px;
  span {
    display: block;
    padding: 0.125rem 0 0;
  }
}
</style>
